import { useTranslation } from "react-i18next";
import { cssbuyReviewContent } from "@/mocks/cssbuy-review-content";
import ArticlePage from "@/components/feature/ArticlePage";

export default function CSSBuyReviewPage() {
  const { i18n } = useTranslation();
  const lang = i18n.language as "en" | "pt-BR" | "de";
  const content = cssbuyReviewContent[lang] || cssbuyReviewContent.en;

  return <ArticlePage content={content} />;
}